import { logAction, useRelodeReducer, useSnackMiddleware } from "@relode/core";
import * as React from "react";

import { JobSearchActions, useJobSearchActions } from "./jobSearchActions";
import { useJobSearchHandlers } from "./jobSearchHandlers";
import { jobSearchReducer } from "./jobSearchReducer";
import { initialJobSearchState, SearchState } from "./jobSearchState";

export type JobSearchContextType = [SearchState, JobSearchActions];

export const JobSearchContext = React.createContext<any>(undefined);

export const JobSearchProvider = (props: { children: React.ReactNode }) => {
    const [state, dispatch] = useRelodeReducer(
        jobSearchReducer,
        initialJobSearchState,
        [useSnackMiddleware(), logAction]
    );

    const actions = useJobSearchActions(dispatch);
    useJobSearchHandlers(state, actions);
    const value = React.useMemo(() => [state, actions], [
        actions,
        state,
    ]) as JobSearchContextType;

    return <JobSearchContext.Provider value={value} {...props} />;
};

export const useJobSearch = () => {
    const context = React.useContext(JobSearchContext);
    if (!context) {
        throw new Error("useJobSearch must be used within a JobSearchProvider");
    }
    return context as JobSearchContextType;
};
